export default __webpack_public_path__ + "static/media/books.c024a729.jpg";